// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__wQJWq","list":"BalanceDue_list__37OZR","listRow":"BalanceDue_listRow__c4shY","total":"BalanceDue_total__2Jxr9"};